import { createContext, useContext, ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { HAS_COMPLETIONS_QUERY } from '~/graphql/queries';
import { useAuth } from '~/context/auth';

interface CompletionsContextType {
  hasCompletions: boolean;
  completionsLoading: boolean;
}

const CompletionsContext = createContext<CompletionsContextType | undefined>(undefined);

export function CompletionsProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const { data, loading } = useQuery(HAS_COMPLETIONS_QUERY, {
    skip: !user,
    fetchPolicy: 'cache-and-network',
  });

  const hasCompletions = data?.hasCompletions || false;

  return (
    <CompletionsContext.Provider value={{ hasCompletions, completionsLoading: loading }}>
      {children}
    </CompletionsContext.Provider>
  );
}

export function useCompletions() {
  const context = useContext(CompletionsContext);
  if (context === undefined) {
    throw new Error('useCompletions must be used within a CompletionsProvider');
  }
  return context;
}
